export default __webpack_public_path__ + "static/media/service.f6045739.jpg";